/** Diff de líneas (LCS clásico) para el tab «Diff vA → vB» del banco. Puro. */
export interface DiffLine { kind: "same" | "add" | "del"; n: number; text: string }
export function diffLines(a: string, b: string): DiffLine[] {
  const A = a.split("\n"), B = b.split("\n");
  const m = A.length, n = B.length;
  const L: number[][] = Array.from({ length: m + 1 }, () => new Array<number>(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--) for (let j = n - 1; j >= 0; j--) L[i]![j] = A[i] === B[j] ? L[i + 1]![j + 1]! + 1 : Math.max(L[i + 1]![j]!, L[i]![j + 1]!);
  const out: DiffLine[] = [];
  let i = 0, j = 0;
  while (i < m && j < n) {
    if (A[i] === B[j]) { out.push({ kind: "same", n: j + 1, text: B[j]! }); i++; j++; }
    else if (L[i + 1]![j]! >= L[i]![j + 1]!) { out.push({ kind: "del", n: i + 1, text: A[i]! }); i++; }
    else { out.push({ kind: "add", n: j + 1, text: B[j]! }); j++; }
  }
  while (i < m) { out.push({ kind: "del", n: i + 1, text: A[i]! }); i++; }
  while (j < n) { out.push({ kind: "add", n: j + 1, text: B[j]! }); j++; }
  return out;
}
/** Contexto: solo cambios ± `ctx` líneas alrededor (como enseña el prototipo). */
export function diffHunks(lines: DiffLine[], ctx = 1): DiffLine[] {
  const keep = new Set<number>();
  lines.forEach((l, idx) => { if (l.kind !== "same") for (let k = idx - ctx; k <= idx + ctx; k++) keep.add(k); });
  return lines.filter((_, idx) => keep.has(idx));
}
